export function sortableExportFilename(
  name: string,
  exportType: string,
  extension: string,
  timestamp: Date | string = new Date(),
): string {
  const date = timestamp instanceof Date ? timestamp : new Date(timestamp);
  if (Number.isNaN(date.getTime())) throw new Error("Export timestamp is invalid.");
  const sortableTimestamp = `${date.toISOString().slice(0, 19).replace("T", "_").replaceAll(":", "-")}Z`;
  const slug = name.trim().replace(/[^a-z0-9]+/gi, "-").replace(/^-|-$/g, "").toLowerCase()
    || "planning-scenario";
  const typeSlug = exportType.trim().replace(/[^a-z0-9]+/gi, "-").replace(/^-|-$/g, "").toLowerCase()
    || "export";
  const normalizedExtension = extension.replace(/^\.+/, "");
  return `${sortableTimestamp}_${typeSlug}_${slug}.${normalizedExtension}`;
}
